import { Checkbox, FormControlLabel } from "@mui/material";
import { ReactElement } from "react";

export interface CheckboxListProps<T> {
  allItems: T[];
  itemKey: (item: T) => string;
  itemName: (item: T) => string;
  onChange: (selected: T[]) => void;
  selected: T[];
}
export default function CheckboxList<T>(props: CheckboxListProps<T>): ReactElement {
  return (
    <>
      {props.allItems.map((item) => (
        <FormControlLabel
          className="h-6"
          key={props.itemKey(item)}
          sx={{ m: 0, p: 0 }}
          control={
            <Checkbox
              size="small"
              checked={props.selected.includes(item)}
              color="default"
              onChange={(event) => {
                if (event.target.checked) {
                  props.onChange([...props.selected, item]);
                } else {
                  props.onChange(props.selected.filter((i) => i !== item));
                }
              }}
            />
          }
          label={props.itemName(item)}
        />
      ))}
    </>
  );
}
